import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/projects",
    component: () =>
      import("../views/Projects.vue"),
  },
  {
    path: "/skills",
    component: () =>
      import("../views/Skills.vue"),
  },
  {
    path: "/valorant",
    component: () =>
      import("../views/Valorant.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
